"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.archiveFile = archiveFile;
exports.unarchiveFile = unarchiveFile;
exports.fetchFiles = fetchFiles;
exports.fetchSingleFile = fetchSingleFile;
exports.fetchIntegratedVideos = fetchIntegratedVideos;
exports.move = move;
exports.uploadFile = uploadFile;
exports.uploadEditedImage = uploadEditedImage;
exports.uploadResizedImage = uploadResizedImage;
exports.saveThumbnail = saveThumbnail;
exports.generateAndUpdateThumbnail = generateAndUpdateThumbnail;
exports.exportFiles = exportFiles;
exports.downloadFromUrl = downloadFromUrl;
exports.remove = remove;
exports.getDownloadUrl = getDownloadUrl;
exports.updateFileMeta = updateFileMeta;
exports.getSignedUrl = getSignedUrl;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = _interopRequireDefault(require("immutable"));

var _enviro = _interopRequireDefault(require("enviro"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var BASE_URI = 'filemanager/api/v2/files';
var BASE_V3_URI = 'filemanager/api/v3/files';
var DEFAULT_QUERY = {
  archived: 0,
  is_cta_image: 0,
  order_by: '-updated'
};

function parseQuery(options) {
  var query = {};

  if (options.get('search')) {
    var search = options.get('search');

    try {
      // decode percent-encoding, which is safe because filenames can't contain %
      search = window.decodeURIComponent(search);
    } catch (e) {} // eslint-disable-line no-empty


    query.name__icontains = search;
  }

  if (options.get('archived')) {
    query.archived = options.get('archived') ? 1 : 0;
  }

  var filtered = options.filter(function (val, key) {
    return ['folder_path', 'folder_id', 'offset', 'limit', 'type', 'archived', 'order_by', 'provider'].indexOf(key) !== -1 && typeof val !== 'undefined';
  });
  return (0, _extends2.default)({}, DEFAULT_QUERY, filtered.toJS(), query);
}

function archiveFile(fileId) {
  var httpClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _apiClient.default;
  var URI = BASE_URI + "/" + fileId + "/archive";
  return httpClient.post(URI, {
    data: {
      archived: true
    }
  }).then(_immutable.default.fromJS);
}

function unarchiveFile(fileId) {
  var httpClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _apiClient.default;
  var URI = BASE_URI + "/" + fileId + "/archive";
  return httpClient.post(URI, {
    data: {
      archived: false
    }
  }).then(_immutable.default.fromJS);
}

function fetchFiles() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var httpClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _apiClient.default;
  var earlyRequesterPromise = arguments.length > 2 ? arguments[2] : undefined;
  var promise = earlyRequesterPromise || httpClient.get(BASE_URI, {
    query: parseQuery(options),
    timeout: 30000
  });
  return promise.then(_immutable.default.fromJS);
}

function fetchSingleFile(fileId) {
  var httpClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _apiClient.default;
  return httpClient.get(BASE_URI + "/" + fileId).then(_immutable.default.fromJS);
}

function fetchIntegratedVideos() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var httpClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _apiClient.default;
  return httpClient.get(BASE_URI + "/integrated-videos", {
    query: parseQuery(options),
    timeout: 15000
  }).then(_immutable.default.fromJS);
}

function move(fileId, options) {
  var httpClient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _apiClient.default;
  var URI = BASE_URI + "/" + fileId + "/move-file";
  return httpClient.post(URI, {
    data: options
  }).then(_immutable.default.fromJS);
}

function uploadFile(file, updateProgress) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var httpClient = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _apiClient.default;
  var xhrCallback = arguments.length > 4 ? arguments[4] : undefined;
  var replaceFileId = options.replaceFileId,
      folderId = options.folderId,
      folderPath = options.folderPath,
      fileName = options.fileName,
      uploadParams = (0, _objectWithoutProperties2.default)(options, ["replaceFileId", "folderId", "folderPath", "fileName"]);
  var url = replaceFileId ? BASE_URI + "/" + replaceFileId : BASE_URI;
  var formData = new FormData();
  formData.append('file', file);

  if (folderId) {
    formData.append('folder_ids', folderId);
  }

  if (folderPath) {
    formData.append('folder_paths', folderPath);
  }

  if (fileName) {
    formData.append('file_names', fileName.replace(/\./gm, '-'));
  }

  return httpClient.post(url, {
    query: uploadParams,
    timeout: 0,
    headers: {
      'content-type': false
    },
    data: formData,
    withXhr: function withXhr(xhr) {
      xhr.upload.addEventListener('progress', updateProgress, false);

      if (xhrCallback) {
        xhrCallback(xhr);
      }
    }
  }).then(_immutable.default.fromJS);
}

function uploadEditedImage(file, fileName, fileFolderId) {
  var httpClient = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _apiClient.default;
  var formData = new FormData();
  formData.append('file', file, fileName.replace(/\./gm, '-'));

  if (fileFolderId) {
    formData.append('folder_ids', fileFolderId);
  }

  return httpClient.post(BASE_URI, {
    timeout: 0,
    headers: {
      'content-type': false
    },
    data: formData
  }).then(_immutable.default.fromJS);
}

function uploadResizedImage(fileId, newWidth) {
  var httpClient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _apiClient.default;
  return httpClient.post(BASE_URI + "/" + fileId + "/resize-image", {
    timeout: 0,
    query: {
      width: newWidth
    }
  }).then(_immutable.default.fromJS);
}

function saveThumbnail(sourceFileId, targetFileId) {
  var httpClient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _apiClient.default;
  return httpClient.post(BASE_V3_URI + "/" + targetFileId + "/thumbnails/replace", {
    data: {
      sourceFileId: sourceFileId
    }
  }).then(_immutable.default.fromJS);
}

function generateAndUpdateThumbnail(targetFileId, thumbnailTimestamp) {
  var httpClient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _apiClient.default;
  return httpClient.post(BASE_V3_URI + "/" + targetFileId + "/thumbnails/generate?", {
    timeout: 35000,
    data: {
      thumbnailTimestamp: thumbnailTimestamp
    }
  }).then(_immutable.default.fromJS);
}

function exportFiles(emailAddress) {
  var filesAndFolders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var httpClient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _apiClient.default;
  var uri = BASE_URI + "/export-all-files";
  return httpClient.post(uri, {
    data: (0, _extends2.default)({
      email_address: emailAddress
    }, filesAndFolders)
  }).then(_immutable.default.fromJS);
}

function downloadFromUrl(file, url) {
  var httpClient = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _apiClient.default;
  var uri = BASE_URI + "/download-from-url";
  return httpClient.post(uri, {
    timeout: 60000,
    data: file.merge({
      url: url
    }).toObject()
  }).then(_immutable.default.fromJS);
}

function remove(fileId) {
  var httpClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _apiClient.default;
  return httpClient.delete(BASE_URI + "/" + fileId);
}

function getDownloadUrl(path, version) {
  var env = _enviro.default.getShort('filemanager');

  var portalId = _hubspot.default.get();

  var host;

  switch (env) {
    case 'local':
      host = 'local.hubspotqa.com';
      break;

    case 'prod':
      host = 'api.hubspot.com';
      break;

    case 'qa':
    default:
      host = 'api.hubspotqa.com';
  }

  return "https://" + host + "/" + BASE_URI + "/download/" + path + "?version=" + version + "&portalId=" + portalId;
}

function updateFileMeta(fileId, data, httpClient) {
  return httpClient.patch(BASE_V3_URI + "/" + fileId + "/meta", {
    data: data
  }).then(_immutable.default.fromJS);
}
/**
 * Fetches a signed download url for the given file id
 * @param {Number} fileId
 * @param {Object} httpClient
 */


function getSignedUrl(fileId) {
  var httpClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _apiClient.default;
  return httpClient.get(BASE_URI + "/" + fileId + "/signed-url", {
    query: {
      'response-content-disposition': 'attachment'
    }
  });
}